<template>
  <div class="top-hero2">
    <div class="container">
      <div id="challange-target">hidden</div>

      <div class="row marginTop">
        <div class="col-md-12">
          <div class="bg-light">
            <v-toolbar color="primary" class="top-hero6" dark flat>
              <v-toolbar-title>Contact Us</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <div class="alert alert-info" role="alert">
                <v-card-title>{{ listing.address }}</v-card-title>
                <p>
                  You can fill the information below to continue.. We already
                  know the house that you are interest
                </p>
                <hr />
              </div>

              <v-form v-model="valid">
                <div class="row">
                  <div class="col">
                    <v-text-field
                      :counter="10"
                      required
                      :rules="nameRules"
                      label="First Name"
                      name="name"
                      v-model="contact.first_name"
                      prepend-icon="mdi-account"
                      type="text"
                    ></v-text-field>
                  </div>

                  <div class="col">
                    <v-text-field
                      label="Last Name"
                      :rules="lastNameRules"
                      :counter="10"
                      required
                      name="last_name"
                      v-model="contact.last_name"
                      prepend-icon="mdi-account"
                      type="text"
                    ></v-text-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <v-text-field
                      :counter="20"
                      required
                      :rules="addressRules"
                      label="Address"
                      name="address"
                      v-model="contact.address"
                      prepend-icon="mdi-account"
                      type="text"
                    ></v-text-field>
                  </div>

                  <div class="col">
                    <v-text-field
                      label="Email"
                      name="email"
                      :rules="emailRules"
                      required
                      v-model="contact.email"
                      prepend-icon="mdi-account"
                      type="email"
                    ></v-text-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <v-text-field
                      :rules="phoneRules"
                      :counter="12"
                      required
                      label="Phone Number"
                      name="phone"
                      v-model="contact.phone"
                      prepend-icon="mdi-account"
                      type="text"
                    ></v-text-field>
                  </div>

                  <div class="col">
                    Want to: <br />
                    <span class="badge badge-pill badge-primary p-2">Buy</span>
                  </div>
                </div>

                <v-textarea
                  v-model="contact.message"
                  required
                  :rules="messageRules"
                  :counter="150"
                  solo
                  label="Message"
                  rows="4"
                ></v-textarea>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="text-white"
                color="#42A5F5"
                :disabled="!valid"
                @click.prevent="sendMessage"
                >Send Message</v-btn
              >
            </v-card-actions>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    source: String
  },

  data() {
    return {
      listing: this.$route.params.id,
      valid: false,
      contact: {
        first_name: "",
        last_name: "",
        address: "",
        email: "",
        phone: "",
        selected: "buy",
        message: ""
      },

      nameRules: [
        v => !!v || "Name is required",
        v => v.length <= 10 || "Name must be less than 10 characters"
      ],

      lastNameRules: [
        v => !!v || "Last Name is required",
        v => v.length <= 10 || "Name must be less than 10 characters"
      ],

      addressRules: [
        v => !!v || "Address is required",
        v => v.length <= 20 || "Phone must be less than 20 characters"
      ],

      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ],

      phoneRules: [
        v => !!v || "Phone is required",
        v => v.length <= 12 || "Phone must be less than 12 characters"
      ],

      messageRules: [
        v => !!v || "Message is required",
        v => v.length <= 150 || "Message must be less than 150 characters"
      ]
    };
  },

  methods: {
    sendMessage() {
      window.axios.post("/api/messages", this.contact).then(() => {
        this.contact = {};
        alert("Message Sent");
        this.$router.push({ name: "Home" });
      });
    }
  }
};
</script>

<style>
#challange-target {
  display: none;
}

@media (max-width: 1026px) {
  #challange-target {
    display: block;
    margin-top: 65px;
    color: transparent;
  }
}
</style>
